import { DeepPartial, FormTrucker } from '@/types';

export type TruckerProfileState = {
  data: DeepPartial<FormTrucker>;
  isAllDone: boolean;
  isLoading: boolean;
  isLoaded: boolean;
  triedSearch: boolean;
  isAutoLoading: boolean;
  isAutoLoaded: boolean;
  isCpfAutoLoaded: boolean;
  isCellPhoneAutoLoaded: boolean;
  isAllAutoLoaded: boolean;
};

export const truckerProfileActions = [
  'trucker_profile_clean_data',
  'trucker_profile_load_start',
  'trucker_profile_load_end',
  'trucker_profile_auto_load_start',
  'trucker_profile_auto_load_end',
  'trucker_profile_all_auto_loaded',
  'trucker_profile_try_search',
  'trucker_profile_update_data',
  'trucker_profile_set_all_done',
] as const;

export type TruckerProfileStateAction = (typeof truckerProfileActions)[number];
